<template>
    <transition
        name="slide"
        @after-leave="$emit('after-leave')"
    >
        <slot></slot>
    </transition>
</template>

<script setup lang="ts">
defineEmits(['after-leave']);
</script>

<style scoped lang="scss">
/* Slide transition styles */
.slide-enter-active {
  transition: all 0.5s ease-out;
}

.slide-leave-active {
  transition: all 0.5s ease-out;
}

.slide-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>

